(function () {
  'use strict';

  function setupGallery(gallery) {
    if (!gallery || gallery.dataset.desktopGalleryReady === 'true') return;

    var productRoot = gallery.closest('.Product-Page');
    if (productRoot && gallery.classList.contains('ever-product-gallery--repeat')) {
      productRoot.classList.add('Product-Page--repeat');
    }

    var zoomButtons = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-zoom]'));
    var moreButton = gallery.querySelector('[data-gallery-more]');
    var lightbox = gallery.parentElement && gallery.parentElement.querySelector('[data-gallery-lightbox]');

    gallery.dataset.desktopGalleryReady = 'true';

    if (moreButton) {
      moreButton.addEventListener('click', function () {
        var expanded = gallery.classList.toggle('is-expanded');
        var moreLabel = moreButton.querySelector('[data-gallery-more-label]');
        var lessLabel = moreButton.querySelector('[data-gallery-less-label]');

        moreButton.setAttribute('aria-expanded', String(expanded));
        if (moreLabel) moreLabel.hidden = expanded;
        if (lessLabel) lessLabel.hidden = !expanded;
      });
    }

    if (!lightbox || !zoomButtons.length) return;

    var image = lightbox.querySelector('[data-gallery-lightbox-image]');
    var closeButton = lightbox.querySelector('[data-gallery-lightbox-close]');
    var previousButton = lightbox.querySelector('[data-gallery-lightbox-prev]');
    var nextButton = lightbox.querySelector('[data-gallery-lightbox-next]');
    var currentIndex = 0;
    var imageAnimation = null;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function applyNaturalImageSize() {
      if (!image.naturalWidth || !image.naturalHeight) return;
      image.style.setProperty('--ever-gallery-natural-width', image.naturalWidth + 'px');
      image.style.setProperty('--ever-gallery-natural-height', image.naturalHeight + 'px');
    }

    image.addEventListener('load', applyNaturalImageSize);

    function updateImage(index) {
      currentIndex = (index + zoomButtons.length) % zoomButtons.length;
      var trigger = zoomButtons[currentIndex];
      var source = trigger.getAttribute('data-gallery-full-src');
      var alt = trigger.getAttribute('data-gallery-alt') || '';

      image.src = source;
      image.alt = alt;
      if (image.complete) applyNaturalImageSize();

      var hasMultipleImages = zoomButtons.length > 1;
      previousButton.hidden = !hasMultipleImages;
      nextButton.hidden = !hasMultipleImages;
    }

    function render(index, direction) {
      var targetIndex = (index + zoomButtons.length) % zoomButtons.length;

      if (!direction || reducedMotion.matches || typeof image.animate !== 'function') {
        updateImage(targetIndex);
        return;
      }

      if (imageAnimation) imageAnimation.cancel();

      var exitOffset = direction === 'next' ? -28 : 28;
      var enterOffset = direction === 'next' ? 28 : -28;

      imageAnimation = image.animate([
        { opacity: 1, transform: 'translate3d(0,0,0) scale(1)' },
        { opacity: 0, transform: 'translate3d(' + exitOffset + 'px,0,0) scale(.985)' }
      ], {
        duration: 150,
        easing: 'cubic-bezier(.4,0,1,1)',
        fill: 'forwards'
      });

      imageAnimation.finished.then(function () {
        updateImage(targetIndex);
        imageAnimation = image.animate([
          { opacity: 0, transform: 'translate3d(' + enterOffset + 'px,0,0) scale(.985)' },
          { opacity: 1, transform: 'translate3d(0,0,0) scale(1)' }
        ], {
          duration: 280,
          easing: 'cubic-bezier(.22,1,.36,1)',
          fill: 'both'
        });
      }).catch(function () {});
    }

    function open(index) {
      render(index);
      if (typeof lightbox.showModal === 'function') {
        lightbox.showModal();
      } else {
        lightbox.setAttribute('open', '');
      }
      document.documentElement.classList.add('ever-gallery-lightbox-open');
    }

    function close() {
      if (typeof lightbox.close === 'function' && lightbox.open) {
        lightbox.close();
      } else {
        lightbox.removeAttribute('open');
      }
      document.documentElement.classList.remove('ever-gallery-lightbox-open');
    }

    zoomButtons.forEach(function (button, index) {
      button.addEventListener('click', function () { open(index); });
    });

    closeButton.addEventListener('click', close);
    previousButton.addEventListener('click', function () { render(currentIndex - 1, 'previous'); });
    nextButton.addEventListener('click', function () { render(currentIndex + 1, 'next'); });

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) close();
    });

    lightbox.addEventListener('close', function () {
      document.documentElement.classList.remove('ever-gallery-lightbox-open');
    });

    lightbox.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') render(currentIndex - 1, 'previous');
      if (event.key === 'ArrowRight') render(currentIndex + 1, 'next');
    });
  }

  function init() {
    document.querySelectorAll('[data-product-gallery]').forEach(setupGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
